// Ürün Aktarma penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.transferItem';

export const salesTransferItemGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Ürün Aktarma nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Masadaki ürünlerin bir kısmını veya tamamını başka bir masaya taşırsınız. Pencere üç adımda ilerler: Ürün Seç → Masa Seç → Onay. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ürün Aktarma - adım adı'),
    body: t(`${G}.regions.body`, 'Ürünler / masalar'),
    footer: t(`${G}.regions.footer`, 'İptal / Geri / Aktar'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Aktarılacak ürünleri seçin'),
      text: t(`${G}.s1.text`, '"Ürün Seç" adımında masadaki ürünler listelenir. Taşımak istediklerinize dokunarak işaretleyin; hepsini taşımak için "Tümünü Seç"i kullanın. Sonra "Aktar (… ürün)" düğmesine basın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Seçilen satır, sepetteki miktarının tamamıyla taşınır; bir satırın yalnız bir kısmı aktarılamaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Hedef masayı seçin'),
      text: t(`${G}.s2.text`, '"Masa Seç" adımında soldaki gruplardan birini seçin (küçük ekranda üstteki açılır liste), sonra hedef masaya dokunun ve "Bu Masaya Aktar"a basın. Bulunduğunuz masa listede yer almaz.'),
      tips: [
        t(`${G}.s2.tip1`, 'Yeşil ve "Dolu" yazan masalar şu anda açıktır; beyaz masalar kapalıdır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Onaylayın'),
      text: t(`${G}.s3.text`, 'Hedef masa kapalıysa "Masa Aç ve Aktar" sorusu gelir: "Masayı Aç ve Taşı" ile masa açılır ve ürünler oraya taşınır. Hedef masa açıksa "Aktarma Onayı" gelir: "Evet, Aktar" ile ürünler o masanın adisyonuna eklenir. "Geri" ile masa seçimine dönebilirsiniz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Aktarma sonrası'),
      text: t(`${G}.s4.text`, 'Taşınan ürünlerin mutfağa yazdırılmış bilgisi korunur; hedef masada yeniden mutfağa gönderilmez. İşlem her iki masanın "Geçmiş" kaydına yazılır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Kaynak masada ürün kalmazsa adisyonu 0 tutarla kendiliğinden kapanır; Restoran Raporlarında "Adisyon İptalleri" sekmesinde "Ürün Aktarma" olarak görünür.'),
        t(`${G}.s4.tip2`, 'Ürün aktarmak için masa aktarma yetkisi gerekir. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
